import types from './types'

export default {
  setAffectedPermissionData(context, affectedPermissionData) {
    context.commit(types.SET_AFFECTED_PERMISSION, affectedPermissionData)
  },
}
